export default "__VITE_ASSET__DJGgw0c6__"